import { createFileRoute } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';
import { AuditPage } from '@/features/security/audit-page';
import { ConsoleShell } from '@/features/shell/console-shell';

export const Route = createFileRoute('/$tenant/audit')({ component: AuditRoute });

function AuditRoute() {
  const { tenant } = Route.useParams();
  const { t } = useTranslation();
  return (
    <ConsoleShell tenantId={tenant} activeItem="audit" crumbs={[{ label: t('security.audit.title') }]}>
      <AuditPage tenantId={tenant} />
    </ConsoleShell>
  );
}
